import CustomLink from "components/CustomLink";
import CustomTab from "components/CustomTab";
import CustomTable from "components/CustomTable";
import ExportReactCSV from "components/ExportReactCSV";
import { CustomStatusBadge } from "components/StatusBadge";
import PaperButton from "components/buttons/PaperButton";
import CustomText from "components/typography/CustomText";
import { currency } from "lib/formatter";
import {
  boxStatusOptions,
  orderStatusOptions,
  paymentStatusOption,
} from "lib/global";
import moment from "moment";
import { useState } from "react";

const tabs = [
  // { label: "All Orders", tab: "all" },
  { label: "Subscriptions", tab: "sub" },
  { label: "One-off Orders", tab: "one_off" },
];

export default function SubscriptionTable({ data = [] }) {
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const headers = [
    { label: activeTab.tab === "sub" ? "Sub ID" : "Order ID", key: "id" },
    { label: "Created", key: "created_date" },
    { label: "Amount", key: "amount" },
    ...[
      ...(activeTab.tab === "sub"
        ? [{ label: "Frequency", key: "frequency" }]
        : []),
    ],
    activeTab.tab === "sub"
      ? { label: "Next Dispatch", key: "next_dispatch" }
      : { label: "Dispatch Date", key: "dispatch_date" },
    { label: "Address", key: "address" },
    ...[
      ...(activeTab.tab === "sub" ? [{ label: "Status", key: "status" }] : []),
    ],
    ...[
      ...(activeTab.tab === "one_off"
        ? [{ label: "Payment", key: "payment" }]
        : []),
    ],
    ...[
      ...(activeTab.tab === "one_off"
        ? [{ label: "Status", key: "delivery_status" }]
        : []),
    ],
  ];
  const userSubs = () => {
    let custs = data
      .filter(
        (item) => item.box_type === (activeTab.tab === "sub" ? true : false)
      )
      .map((row) => ({
        id: activeTab.tab === "sub" ? row?.id : row?.weekly_slot_id,
        created_date: moment(row?.created_at).format("MM/DD/YY"),
        amount: currency.format(row.total),
        frequency: `${row?.frequency} weeks`,
        next_dispatch: `${
          row?.week_next_num || (+(row?.frequency ?? 2) + row?.week_num ?? 0)
        } weeks`,
        dispatch_date: moment()
          .set({
            year: row?.week_year,
            isoWeek: row?.week_num,
            isoWeekday: row?.week_day,
          })
          .format("MM/DD/YY"),
        address: row?.address?.label ?? "",
        status:
          (
            boxStatusOptions?.filter(
              (item) => item?.value === row?.status
            )?.[0] ?? {}
          )?.label ?? "Active",
        payment:
          paymentStatusOption?.find((item) => item?.id === row?.paid).label ??
          "",
        delivery_status:
          orderStatusOptions?.find((item) => item?.id === row?.delivery_status)
            .label ?? "",
      }));
    return custs;
  };

  return (
    <div>
      <div className="mb-0.5">
        <div className="flex justify-between items-center">
          <CustomTab
            tabs={tabs}
            activeTab={activeTab}
            onClick={(tab) => setActiveTab(tab)}
          />
          <ExportReactCSV
            csvHeaders={headers}
            csvData={userSubs()}
            fileName={`${activeTab?.label ?? "Orders"}.csv`}
          />
        </div>
      </div>

      <CustomTable
        data={data.filter(
          (item, index) =>
            item.box_type === (activeTab.tab === "sub" ? true : false)
        )}
        height={500}
        pageCount={50}
        // toolbar={
        //   <div className="p-4 border-b border-white-gray flex justify-between items-center">
        //     <CustomText variant="h6" bold={600}>
        //       Subscriptions
        //     </CustomText>
        //     <ExportReactCSV
        //       csvHeaders={headers}
        //       csvData={userSubs()}
        //       fileName={`userSubsriptions.csv`}
        //     />
        //   </div>
        // }
        columns={[
          {
            label: `${activeTab.tab === "sub" ? "SUB" : "ORDER"} ID`,
            selector: "id",
            cell: (row) => (
              <CustomLink
                to={
                  activeTab.tab === "sub"
                    ? `/subscriptions/${row?.id ?? ""}`
                    : `/order/${row?.weekly_slot_id ?? ""}`
                }
              >
                <CustomText
                  className="py-2"
                  variant="custom13"
                  color="primary"
                  bold
                >
                  {activeTab.tab === "sub" ? row?.id : row?.weekly_slot_id}
                </CustomText>
              </CustomLink>
            ),
          },
          {
            label: "CREATED",
            selector: "created_at",
            sortValue: (row) => moment(row?.created_at).unix(),
            cell: (row) => (
              <CustomText color="secondary" variant="custom13">
                {moment(row?.created_at).format("MM/DD/YY")}
              </CustomText>
            ),
          },
          {
            label: "VALUE",
            selector: "value",
            sortValue: (row) => +row.total,
            cell: (row) => (
              <CustomText color="secondary" variant="custom13">
                {currency.format(row.total)}
              </CustomText>
            ),
          },
          ...[
            ...(activeTab.tab === "sub"
              ? [
                  {
                    label: "FREQUENCY",
                    selector: "frequency",
                    cell: (row) => (
                      <CustomText
                        color="secondary"
                        variant="custom13"
                      >{`${row?.frequency} weeks`}</CustomText>
                    ),
                  },
                ]
              : []),
          ],
          {
            label: activeTab.tab === "sub" ? "NEXT DISPATCH" : "DELIVERY DATE",
            selector: "weeK_next_num",
            sortValue: (row) =>
              row?.week_next_num ||
              (+(row?.frequency ?? 2) + row?.week_num ?? 0),
            cell: (row) => (
              <CustomText color="secondary" variant="custom13">
                {row?.box_type
                  ? `${
                      row?.week_next_num ||
                      (+(row?.frequency ?? 2) + row?.week_num ?? 0)
                    } week`
                  : moment()
                      .set({
                        year: row?.week_year,
                        isoWeek: row?.week_num,
                        isoWeekday: row?.week_day,
                      })
                      .format("MM/DD/YY")}
              </CustomText>
            ),
          },
          {
            label: "ADDRESS",
            selector: "address",
            sortValue: (row) => row?.address?.label ?? "",
            cell: (row) => (
              <CustomText color="primary" variant="custom13" bold>
                {row?.address?.label ?? ""}
              </CustomText>
            ),
          },
          ...[
            ...(activeTab.tab === "sub"
              ? [
                  {
                    label: "STATUS",
                    selector: "status",
                    sortValue: (row) =>
                      (
                        boxStatusOptions?.filter(
                          (item) => item?.value === row?.status
                        )?.[0] ?? {}
                      )?.label ?? "Active",
                    cell: (row) => (
                      <div className="flex items-center">
                        <CustomStatusBadge
                          size="span"
                          variant={
                            row?.status === "1" || !Boolean(row?.status)
                              ? "success"
                              : "error"
                          }
                          text={
                            (
                              boxStatusOptions?.filter(
                                (item) => item?.value === row?.status
                              )?.[0] ?? {}
                            )?.label ?? "Active"
                          }
                        />
                      </div>
                    ),
                  },
                ]
              : []),
          ],
          ...[
            ...(activeTab.tab === "one_off"
              ? [
                  {
                    label: "PAYMENT",
                    selector: "Payment",
                    sortValue: (row) =>
                      paymentStatusOption?.find(
                        (item) => item?.id === row?.paid
                      ).label ?? "",
                    cell: (row) => (
                      <div className="flex items-center">
                        <CustomStatusBadge
                          size="span"
                          variant={
                            paymentStatusOption?.find(
                              (item) => item?.id === row?.paid
                            ).variant ?? ""
                          }
                          text={
                            paymentStatusOption?.find(
                              (item) => item?.id === row?.paid
                            ).label ?? ""
                          }
                        />
                      </div>
                    ),
                  },
                ]
              : []),
          ],
          ...[
            ...(activeTab.tab === "one_off"
              ? [
                  {
                    label: "STATUS",
                    selector: "status",
                    sortValue: (row) =>
                      orderStatusOptions?.find(
                        (item) => item?.id === row?.delivery_status
                      ).label ?? "",
                    cell: (row) => (
                      <div className="flex items-center">
                        <CustomStatusBadge
                          size="span"
                          variant={
                            orderStatusOptions?.find(
                              (item) => item?.id === row?.delivery_status
                            ).variant ?? ""
                          }
                          text={
                            orderStatusOptions?.find(
                              (item) => item?.id === row?.delivery_status
                            ).label ?? ""
                          }
                        />
                      </div>
                    ),
                  },
                ]
              : []),
          ],
          {
            label: " ",
            selector: "actions",
            cell: (row, rowIndex) => (
              <CustomLink
                to={
                  activeTab.tab === "sub"
                    ? `/subscriptions/${row?.id ?? ""}`
                    : `/order/${row?.weekly_slot_id ?? ""}`
                }
              >
                <PaperButton
                  className="text-13"
                  variant="text"
                  color="primary"
                  // onClick={() => onView(row, rowIndex)}
                >
                  View Details
                </PaperButton>
              </CustomLink>
            ),
          },
        ]}
        // onSelect={(row) =>
        //   activeTab.tab === "sub"
        //     ? history.push(`/subscriptions/${row.id}`)
        //     : history.push(`/order/${row.weekly_slot_id}`)
        // }
      />
    </div>
  );
}
